import useLoginCheck from 'hooks/common/useLoginCheck';
import * as usersAPI from 'lib/api/service/users';
import {
  addUsersLoading,
  changeProp,
  subtractUsersLoading,
} from 'modules/serviceSlice';
import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

const useUsersTable = (userType, search, currentPage, setCurrentPage) => {
  const dispatch = useDispatch();

  const { isLoading, error, isSuccess, data, refetch } = useQuery(
    [`users`, currentPage, search, userType],
    () => usersAPI.getUsers(currentPage, search, userType),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: true,
    },
  );
  useLoginCheck(error?.response, refetch);

  useEffect(() => {
    if (isLoading) {
      dispatch(addUsersLoading(userType));
    }
    if (error?.response.status === 500) {
      dispatch(changeProp({ key: 'serviceError', value: true }));
    }
    if (isSuccess) {
      dispatch(subtractUsersLoading(userType));
    }
  }, [isLoading, isSuccess, dispatch, userType, error]);

  return {
    isLoading,
    data,
    currentPage,
    setCurrentPage,
  };
};

export default useUsersTable;
